<template>
  <div class="lp-adm-drop-input-container">

    <div class="drop-input-select-wrapper"
         @click.capture="isOpen=true"
         :style="wrapperStyle">
      <input class="drop-input-input"
             type="text"
             :value="selectedLabel"
             @input="searchKeyword"
             @focus="isOpen=true"
             @keyup.enter="onEnter"
             :placeholder="placeholder">
      <div class="drop-button">
        <i v-if="!isOpen"
           @click.stop.prevent="isOpen=true"
           class="material-icons drop-input-arrow-icon">keyboard_arrow_down</i>
        <i v-if="isOpen"
           @click.stop.prevent="isOpen=false"
           class="material-icons drop-input-arrow-icon">keyboard_arrow_up</i>
      </div>
    </div>

    <!--@mouseover.stop.prevent="trigger=false"
    @mouseleave.stop.prevent="trigger=true"-->
    <div v-if="isOpen && list.length!==0"
         class="drop-input-list"
         :style="listStyle">
      <div class="flex-align remove-selected-item" v-if="!isSelectedItem">
        <span class="unselect" @click="addAllSelectedItem">전체 선택</span>
      </div>
      <div class="remove-selected-item" v-else>
        <span class="unselect" @click="removeSelectedItem">선택 항목 지우기</span>
      </div>
      <!--   선택된 목록   -->
      <div class="drop-input-item"
           v-for="(item, idx) in list"
           :key="'sort-list'+idx" v-if="item.selected">
        <div class="flex-align" @click.stop.prevent="clickTargetItem(item)">
          <lp-check-bool
            style="margin-right:12px"
            :checkedVal.sync="item.selected"></lp-check-bool>
          <span>{{ labelName(item.label) }}</span></div>
      </div>
      <!--   구분선  -->
      <div style="height:1px;background-color:#cccccc;margin:0 12px" v-if="showDivider"></div>
      <!--   선택 안된 목록   -->
      <div class="drop-input-item"
           v-for="(item, idx) in list"
           :key="'sort-list'+idx" v-if="!item.selected">
        <div class="flex-align" @click.stop.prevent="clickTargetItem(item)">
          <lp-check-bool
            style="margin-right:12px"
            :checkedVal.sync="item.selected"></lp-check-bool>
          <span>{{ labelName(item.label) }}</span></div>
      </div>
    </div>

    <div v-if="isOpen" class="lp-outsider-layout" @click="clickOutSider"></div>

  </div>
</template>

<script>
  import LpCheckBool from "./LpCheckBool";

  export default {
    // replace: 선택한 값으로 선정할 키값 ex)
    name: 'LpMultipleDropInput',
    components: {LpCheckBool},
    props: {
      'data': {
        type: Array,
        default: []
      },
      'placeholder': {
        type: String,
        default: ''
      },
      'width': {
        type: String,
        default: '100px'
      },
      'number_length': {
        type: Number,
        default: 10
      },
      'selectVal': {
        type: [String, Number],
        default: ''
      },
      'added_field': {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        trigger: false,
        isOpen: false,
        selectedLabel: '',
        list: [],
        test: [],
        select_all: false
        //disabled: true
      }
    },
    created() {
      this.list = this.data;

      /*if (this.list.length>0) {
        this.disabled = false;
      }*/
      this.selectedLabel = this.selectVal;
    },
    computed: {
      showDivider () {
        let list_cnt = 0;
        this.list.forEach(item => {
          if(item.selected) list_cnt += 1;
        })
        if(0 < list_cnt && list_cnt < this.list.length) {
          return true;
        }
        else return false;
      },
      isSelectedItem () {
        let is_item = false;
        this.list.some(item => {
          if(item.selected) is_item=true;
        })
        return is_item;
      },
      wrapperStyle() {
        let style = {};
        if (this.width !== undefined) {
          style.width = this.width;
        }
        return style;
      },
      listStyle() {
        let style = {};
        if (this.width !== undefined) {
          style.width = this.width;
        }
        if (this.listAlign !== undefined) {
          style.textAlign = this.listAlign;
        }
        return style;
      }
    },
    watch: {
      data(n) {
        this.list = n;
      },
      selectVal(n) {
        this.selectedLabel = this.selectVal;
      }
    },
    methods: {
      onEnter() {
        // 인풋에서 엔터키 입력시, 목록중 첫번째 값 반영
        if (this.list.length > 0) {
          this.clickTargetItem(this.list[0]);
        }

        this.isOpen = false;

      },
      labelName(label) {
        let full_text = '';
        let sep = label.split('/')
        for (let i = 0; i < sep.length; i++) {
          if (sep.length - 1 > i) {
            full_text += sep[i] + '\n'
          } else full_text += sep[i]
        }
        return full_text;
      },
      // 바깥 쪽 선택시 값 원래되로 돌리기
      clickOutSider() {
        this.isOpen = false;
      },
      searchKeyword(e) {
        this.selectedLabel = e.target.value;
        this.list = [];
        if (this.selectedLabel === '') {
          this.list = this.data;
        } else {
          for (let i = 0; i < this.data.length; i++) {
            // let reg = new RegExp('^' + this.selectedLabel);
            let isContain = this.data[i].label.toString().search(this.selectedLabel);

            if (isContain > -1) {
              if (!this.added_field) {
                this.list.push(this.data[i]);
              } else {
                this.list.push(this.data[i]);
                for (let i = 0; i < this.list.length; i++) {
                  this.list[i][this.added_field] = this.data[i][this.added_field];
                }
              }
            }
            if (this.selectedLabel.length > this.number_length) {
              this.selectedLabel = this.selectedLabel.substr(0, this.number_length);
            }
          }
        }
      },
      clickTargetItem(item) {
        item.selected = !item.selected;
        this.emitSelected();
      },
      onBlur() {
        if (this.trigger) {
          this.isOpen = false;
        }
      },
      removeSelectedItem () {
        this.select_all = false;
        this.list.forEach(item => {
          item.selected = false;
        })
        this.emitSelected();
      },
      addAllSelectedItem () {
        this.select_all = true;
        this.list.forEach(item => {
          item.selected = true;
        })
        this.emitSelected();
      },
      emitSelected() {
        let list = [];
        this.list.forEach(item => {
          if (item.selected) {
            list.push(item.value);
          }
        })
        this.$emit('onSelect', list);
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  .lp-adm-drop-input-container
    position relative

  @media (max-width: 768px)
    .lp-adm-drop-input-container
      margin-bottom 12px

    .lp-adm-drop-input-container:last-child
      margin-bottom 0

  .drop-input-select-wrapper
    box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
    //width 240px
    border 1px solid #ccc
    border-radius 3px
    display flex
    align-items center
    background-color white

  .drop-input-input
    box-shadow inset 0 1px 2px rgba(10, 10, 10, 0.1)
    width calc(100% - 17px)
    border none
    border-right 1px solid #ccc
    font-size .9rem
    padding 7px 12px
    padding-right 0
    color #333
    outline none

  .drop-button
    text-align center
    height 1rem

  .drop-input-arrow-icon
    font-size 1.2rem
    cursor pointer

  .drop-input-list
    list-style none
    margin 0
    padding 0
    background-color #fff
    border 1px solid #ddd
    border-top none
    //width calc(100% - 21px)
    /*height 192px*/
    width 100%
    max-height: 192px;
    overflow-y auto
    position absolute
    //top 31px
    top 31px
    left inherit
    z-index 11

  .drop-input-item
    font-size .9rem
    color #555
    /*height 36px*/
    /*line-height 36px*/
    cursor pointer
    white-space pre-line
    padding 6px 12px

  .drop-input-item:hover
    background-color #ddd

  // input placeholder style
  // .drop-input-input::-webkit-input-placeholder

  .lp-outsider-layout
    position fixed
    z-index 10
    top 0
    left 0
    right 0
    bottom 0

  .remove-selected-item
    color #363636
    font-size 13px
    padding 6px 12px

</style>
